module.exports = __webpack_public_path__ + "img/bg_weigui.b96044ad.png";